<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />

        <action-button type="delete" @click="del(participant.id)" v-if="participant.id && $hasRole('system-developer') && modal != true" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md2 sm12 xs12 class="pr-4">
                <v-chip v-if="participant.unique_id" small class="mb-3" color="primary">{{
                  $t("participants.unique_id") + ": " + (participant.unique_id ? participant.unique_id : "")
                }}</v-chip>
                <v-img
                  :src="participant.image_url ? participant.image_url : ''"
                  :height="$vuetify.breakpoint.smAndDown ? $vuetify.breakpoint.height / 2 : 'auto'"
                  contain
                >
                </v-img>
                <action-button
                  type="default"
                  :text="$t('participants.verify_image')"
                  @click="verifyImage()"
                  v-if="participant.id && !participant.image_verified && !modal"
                  class="mt-3 mx-0 d-block"
                />

                <div>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="cstm-v-btn darken-2 mt-3 mx-0 d-block info" v-bind="attrs" v-on="on"
                        ><v-icon>camera_alt</v-icon> {{ $t("global.upload") }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-for="(item, index) in uploadSelections" :key="index">
                        <v-list-item-title @click="openUpload(item.key)">{{ item.label }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-flex>
              <v-flex md10 sm12 xs12>
                <v-layout row wrap>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="participant.pid"
                      v-model="participant.pid"
                      :label="$t('participants.pid')"
                      v-validate="'max:11'"
                      :error-messages="errors.collect('participant.pid')"
                      :append-icon="hidePID ? 'visibility_off' : 'visibility'"
                      @click:append="() => (hidePID = !hidePID)"
                      :type="hidePID ? 'password' : 'text'"
                      :readonly="!isAdmin"
                      autocomplete="new-password"
                      @change="PIDChange()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="participant.first_name"
                      v-model="participant.first_name"
                      class="required-field"
                      v-validate="'required|max:50'"
                      :label="$t('participants.first_name')"
                      :error-messages="errors.collect('participant.first_name')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="participant.last_name"
                      v-model="participant.last_name"
                      class="required-field"
                      v-validate="'required|max:50'"
                      :label="$t('participants.last_name')"
                      :error-messages="errors.collect('participant.last_name')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="participant.email"
                      v-model="participant.email"
                      class="required-field"
                      v-validate="'required|email|max:255'"
                      :label="$t('participants.email')"
                      :error-messages="errors.collect('participant.email')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <vue-tel-input-vuetify
                      v-validate="'required|max:50'"
                      class="required-field"
                      :label="$t('participants.mobile')"
                      v-model="participant.mobile"
                      @input="
                        (formattedNumber, { number, valid, country }) => {
                          participant.mobile = number.significant || formattedNumber
                          participant.mobile_code = country.dialCode || null
                        }
                      "
                      placeholder=""
                      name="participant.mobile"
                      :error-messages="errors.collect('participant.mobile')"
                      defaultCountry="NO"
                    ></vue-tel-input-vuetify>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12>
                    <v-dialog ref="dialog" v-model="dob_date_menu" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          name="participant.date_of_birth"
                          v-model="computedDateofBirth"
                          :label="$t('participants.date_of_birth')"
                          :class="$hasRole('organisation-admin') || $hasRole('mercantile-admin') ? '' : 'required-field'"
                          v-validate="$hasRole('organisation-admin') || $hasRole('mercantile-admin') ? 'validDate' : 'required|validDate'"
                          :error-messages="errors.collect('participant.date_of_birth')"
                          append-icon="event"
                          @click:append="dob_date_menu = true"
                          :hint="'Format: ' + DATE_FORMAT"
                          autocomplete="new-password"
                        >
                          <template v-slot:append-outer v-if="participant.id && participant.person.age < 18">
                            <v-icon color="error">error </v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="participant.date_of_birth"
                        first-day-of-week="1"
                        :locale="this.$locale_bcp47()"
                        :max="moment().subtract(1, 'days').format(MYSQL_DATE_FORMAT)"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" class="darken-2" @click="dob_date_menu = false">{{ $t("global.ok") }}</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12 v-if="!participant.id && $hasRole('company')">
                    <v-autocomplete
                      name="participant.company_id"
                      v-model="participant.company_id"
                      item-text="name"
                      item-value="id"
                      :items="companiesdd"
                      :label="$t('participants.company_id')"
                      :error-messages="errors.collect('participant.company_id')"
                      autocomplete="new-password"
                      @change="companiesChange"
                      clearable
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12 v-if="!participant.id && $hasRole('company')">
                    <v-autocomplete
                      name="participant.company_department_id"
                      v-model="participant.company_department_id"
                      item-text="name"
                      item-value="id"
                      :items="departments"
                      :label="$t('enrolments.department')"
                      autocomplete="new-password"
                      clearable
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12 v-if="!participant.id && $hasRole('company') && participant.company_id">
                    <v-text-field
                      name="participant.employee_number"
                      v-model="participant.employee_number"
                      v-validate="'max:20'"
                      :label="$t('participants.employee_number')"
                      :error-messages="errors.collect('participant.employee_number')"
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <!--<v-flex lg2 md4 sm6 xs12>
                    <v-dialog ref="dialog" v-model="dob_employeed_from" persistent width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          name="participant.employeed_from"
                          v-model="computedEmployeedFrom"
                          :label="$t('participants.employeed_from')"
                          v-validate="'validDate'"
                          :error-messages="errors.collect('participant.employeed_from')"
                          append-icon="event"
                          @click:append="dob_employeed_from = true"
                          :hint="'Format: ' + DATE_FORMAT"
                          autocomplete="new-password"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="participant.employeed_from"
                        first-day-of-week="1"
                        :locale="this.$locale_bcp47()"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" class="darken-2" @click="dob_employeed_from = false">{{ $t("global.ok") }}</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>-->
                  <v-flex lg3 md4 sm6 xs12 v-if="participant.id">
                    <v-select
                      name="participant.status"
                      v-model="participant.tenant_user_status"
                      :items="$dd_user_status()"
                      item-text="text"
                      item-value="key"
                      :label="$t('users.status')"
                      class="required-field"
                      v-validate="'required'"
                      :error-messages="errors.collect('participant.status')"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      name="participant.comments"
                      v-model="participant.comments"
                      rows="1"
                      auto-grow
                      :label="$t('participants.comments')"
                      :error-messages="errors.collect('participant.comments')"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 v-if="participant.id && participant.person.age < 18">
                    <p class="red-error-text mb-0 text-caption">
                      {{ $t("participants.age_below_18") }}
                    </p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels v-model="clpsPnlAddressExpand" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlAddressIcon }}</v-icon>
                {{ $t("participants.address_title") }}
              </span>
              <v-spacer></v-spacer>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="participant.street"
                    v-model="participant.street"
                    v-validate="'max:50'"
                    :label="$t('participants.street')"
                    :error-messages="errors.collect('participant.street')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 md4 sm6 xs12>
                  <v-text-field
                    name="participant.zip"
                    v-model="participant.zip"
                    v-validate="'max:6'"
                    :label="$t('participants.zip')"
                    :error-messages="errors.collect('participant.zip')"
                    @change="zipCodeChange"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="participant.city"
                    v-model="participant.city"
                    v-validate="'max:50'"
                    :label="$t('participants.city')"
                    :error-messages="errors.collect('participant.city')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-autocomplete
                    name="participant.country"
                    v-model="participant.country"
                    :items="this.$dd_countries()"
                    item-text="text"
                    item-value="key"
                    :label="$t('participants.country')"
                    autocomplete="new-password"
                    :error-messages="errors.collect('participant.country')"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsPnlCompaniesExpand" class="cstm-filter mt-4 elevation-0" v-if="participant.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlCompaniesIcon }}</v-icon>
                {{ $t("enrolments.title_org") }}
              </span>
              <v-spacer></v-spacer>

              <v-layout row wrap class="pa-0 mt-0">
                <v-flex xs12 class="pa-0">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-text-field
                        :label="$t('global.search')"
                        v-model="search_cmp_params.any"
                        @keydown="checkKeyPressFilterCompany"
                        @click.stop="() => {}"
                        hide-details
                        dark
                        class="pa-0 ma-0"
                        autocomplete="new-password"
                      ></v-text-field>

                      <a v-if="!$hasRole('company', true)">
                        <v-btn small class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="enrorglistpopup_show">
                          <v-icon small>fas fa-plus</v-icon>
                          <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                        </v-btn>
                      </a>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="cmp_headers"
                    :items="companies"
                    :items-per-page="companies.length"
                    :options.sync="cmp_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="cmp_total"
                    :loading="cmp_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.name="{ item }">
                      <router-link :to="{ path: BACKEND_URL + '/enrolments/organisations/view/' + item.id, props: { id: item.id } }">
                        {{ item.name }}
                      </router-link>
                    </template>

                    <template v-slot:item.department_id="{ item }">
                      {{ item.department.name }}
                    </template>
                    <template v-slot:item.user_id="{ item }">
                      <v-simple-checkbox
                        :value="Boolean(item.user_id)"
                        hide-details
                        dense
                        :disabled="loggedinuser.id == item.user_id"
                        @input="companyUserChange(item, !item.user_id ? 'create' : 'delete', $event)"
                      ></v-simple-checkbox>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <action-button
                        type="edit"
                        :icon_only="true"
                        small
                        @click="showForm(item.id, item.participant_id, 'enrolment-organisation-user')"
                      />
                      <action-button small type="delete" @click="removeEmployee(item.id)" :icon_only="true" />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsPnlSGExpand"
          class="cstm-filter mt-4 elevation-0"
          v-if="participant.id && !$hasRole('company', true)"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlSGIcon }}</v-icon>
                {{ $t("studentgroups.title") }}
              </span>
              <v-spacer></v-spacer>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="sg_headers"
                    :items="sg_studentgroups"
                    :items-per-page="sg_studentgroups.length"
                    :options.sync="sg_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="sg_total"
                    :loading="sg_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.name="{ item }">
                      <router-link
                        :to="{ path: BACKEND_URL + '/studentgroups/edit/' + item.studentgroup_id, props: { id: item.studentgroup_id } }"
                      >
                        {{ item.name }}
                      </router-link>
                    </template>
                    <template v-slot:item.educationprogram_id="{ item }">
                      {{ item.educationprogram_name }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      {{ $dd_student_group_status(item.status) }}
                    </template>
                    <template v-slot:item.created_at="{ item }">
                      {{ moment.utc(item.created_at).format(DATE_FORMAT) + " " + moment.utc(item.created_at).format(TIME_FORMAT) }}
                    </template>
                    <template v-slot:item.updated_at="{ item }">
                      {{ moment.utc(item.updated_at).format(DATE_FORMAT) + " " + moment.utc(item.updated_at).format(TIME_FORMAT) }}
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsPnlINExpand"
          class="cstm-filter mt-4 elevation-0"
          v-if="participant.id && !isCompany && !$hasRole('company', true)"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlINIcon }}</v-icon>
                {{ $t("participants.internal_notes") }}
              </span>
              <v-spacer></v-spacer>
              <v-flex xs6>
                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2 float-right"
                  color="success"
                  @click.stop="showForm(null, participant.id, 'participant-note')"
                  small
                >
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="d-sm-inline cstm-v-btn-text">{{ $t("participants.in_add_note") }}</span>
                </v-btn>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="in_headers"
                    :items="internalnotes"
                    :items-per-page="internalnotes.length"
                    :options.sync="in_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="in_total"
                    :loading="in_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.created_at="{ item }">
                      {{ moment.utc(item.created_at).format(DATE_FORMAT) + " " + moment.utc(item.created_at).format(TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <action-button type="delete" @click="deleteNote(item.id)" :icon_only="true" />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsPnlIntDocExpand"
          class="cstm-filter mt-4 elevation-0"
          v-if="participant.id && !$hasRole('company', true)"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlIntDocIcon }}</v-icon>
                {{ dc_title }}
              </span>
              <v-spacer></v-spacer>

              <v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="info"
                @click.stop="moveCopyFileTo('copy', 'kompetanse')"
                small
                v-if="selectedInternalDocs.length"
              >
                <v-icon small>fas fa-copy</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.copy_to_kompetanse") }}</span>
              </v-btn>

              <v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="info"
                @click.stop="moveCopyFileTo('move', 'kompetanse')"
                small
                v-if="selectedInternalDocs.length"
              >
                <v-icon small>fas fa-file-import</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.move_to_kompetanse") }}</span>
              </v-btn>

              <v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="warning"
                @click.stop="toggleDocumentList"
                small
                v-if="dc_total_deleted > 0 && dc_mode == null"
              >
                <v-icon small>fas fa-trash-restore</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.show_deleted_documents") }}</span>
              </v-btn>

              <v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="info"
                @click.stop="toggleDocumentList"
                small
                v-if="dc_mode == 'deleted'"
              >
                <v-icon small>fas fa-arrow-left</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.show_documents") }}</span>
              </v-btn>

              <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="openUploadDocumentForm('kursweb')" small>
                <v-icon small>fas fa-plus</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.add_documents") }}</span>
              </v-btn>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="dc_headers"
                    :items="documents"
                    v-model="selectedInternalDocs"
                    :items-per-page="documents.length"
                    :options.sync="dc_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="dc_total"
                    :loading="dc_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                    :show-select="dc_show_select"
                    item-key="id"
                  >
                    <template v-slot:item.original_filename="{ item }">
                      <v-btn icon small @click="openUpdateFile(item.id)">
                        <v-icon dark>mdi-pencil</v-icon>
                      </v-btn>
                      {{ item.original_filename }}
                    </template>

                    <template v-slot:item.size="{ item }">
                      {{ $formatBytes(item.size) }}
                    </template>

                    <template v-slot:item.deleted_at="{ item }">
                      {{ moment.utc(item.deleted_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.deleted_on="{ item }">
                      {{ moment.utc(item.deleted_on).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.created_at="{ item }">
                      {{ moment.utc(item.created_at).format(DATE_FORMAT) + " " + moment.utc(item.created_at).format(TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <action-button
                        type="preview"
                        @click="downloadDocument(item.id, item.module, item.original_filename, true)"
                        :icon_only="true"
                        v-if="$hasPreview(item.original_filename) && !item.deleted_at"
                      />

                      <action-button
                        type="download"
                        @click="downloadDocument(item.id, item.module, item.original_filename)"
                        :icon_only="true"
                        v-if="!item.deleted_at"
                      />
                      <action-button v-if="!item.deleted_at" type="delete" @click="deleteDocument(item.id)" :icon_only="true" />
                      <action-button v-if="item.deleted_at" type="restore" @click="restoreDocument(item)" :icon_only="true" />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsPnlDocExpand" class="cstm-filter mt-4 elevation-0" v-if="participant.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlDocIcon }}</v-icon>
                {{ sdc_title }}
              </span>
              <v-spacer></v-spacer>
              <v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="info"
                @click.stop="moveCopyFileTo('copy', 'kursweb')"
                small
                v-if="selectedStudentDocs.length"
              >
                <v-icon small>fas fa-copy</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.copy_to_kursweb") }}</span>
              </v-btn>

              <v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="info"
                @click.stop="moveCopyFileTo('move', 'kursweb')"
                small
                v-if="selectedStudentDocs.length"
              >
                <v-icon small>fas fa-file-import</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.move_to_kursweb") }}</span>
              </v-btn>

              <!--<v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="warning"
                @click.stop="toggleStudentDocumentList"
                small
                v-if="sdc_total_deleted > 0 && sdc_mode == null"
              >
                <v-icon small>fas fa-trash-restore</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.show_deleted_documents") }}</span>
              </v-btn>

              <v-btn
                class="d-flex-inherit cstm-v-btn darken-2"
                color="info"
                @click.stop="toggleStudentDocumentList"
                small
                v-if="sdc_mode == 'deleted'"
              >
                <v-icon small>fas fa-arrow-left</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.show_documents") }}</span>
              </v-btn>-->

              <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="openUploadDocumentForm('kompetanse')" small>
                <v-icon small>fas fa-plus</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("participants.add_documents") }}</span>
              </v-btn>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="sdc_headers"
                    :items="studentdocuments"
                    v-model="selectedStudentDocs"
                    :items-per-page="studentdocuments.length"
                    :options.sync="sdc_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="sdc_total"
                    :loading="sdc_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                    :show-select="sdc_show_select"
                    item-key="id"
                  >
                    <template v-slot:item.original_filename="{ item }">
                      <v-btn icon small @click="openUpdateFile(item.id)">
                        <v-icon dark>mdi-pencil</v-icon>
                      </v-btn>
                      {{ item.original_filename }}
                    </template>

                    <template v-slot:item.size="{ item }">
                      {{ $formatBytes(item.size) }}
                    </template>

                    <template v-slot:item.created_at="{ item }">
                      {{ moment.utc(item.created_at).format(DATE_FORMAT) + " " + moment.utc(item.created_at).format(TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.deleted_at="{ item }">
                      {{ moment.utc(item.deleted_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.deleted_on="{ item }">
                      {{ moment.utc(item.deleted_on).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <action-button
                        type="preview"
                        @click="downloadDocument(item.id, item.module, item.original_filename, true)"
                        :icon_only="true"
                        v-if="$hasPreview(item.original_filename) && !item.deleted_at"
                      />

                      <action-button
                        type="download"
                        @click="downloadDocument(item.id, item.module, item.original_filename)"
                        :icon_only="true"
                        v-if="!item.deleted_at"
                      />

                      <action-button v-if="item.deleted_at" type="restore" @click="restoreStudentDocument(item)" :icon_only="true" />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsPnlCourseExpand" class="cstm-filter mt-4 elevation-0" v-if="participant.id && !modal">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlCourseIcon }}</v-icon>
                {{ $t("courses.title") }}
              </span>
              <v-spacer></v-spacer>
              <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="courselistpopup_show" small>
                <v-icon small>fas fa-plus</v-icon>
                <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("enrolments.enrol") }}</span>
              </v-btn>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  :headers="course_headers"
                  :items="courses"
                  :items-per-page="courses.length"
                  :options.sync="course_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="course_total"
                  :loading="course_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.name="{ item }">
                    {{ item.name }}
                    <v-icon
                      @click="showCourseCommentModal(item.id, item.comment)"
                      class="ml-2"
                      color="black"
                      outline
                      small
                      v-if="!isCompany"
                      >{{ item.comment ? "fas fa-comment" : "far fa-comment" }}</v-icon
                    >
                  </template>

                  <template v-slot:item.start_datetime="{ item }">
                    {{ item.start_date ? moment.utc(item.start_date).format(DATE_FORMAT) : null }}
                  </template>

                  <template v-slot:item.end_datetime="{ item }">
                    {{ item.end_date ? moment.utc(item.end_date).format(DATE_FORMAT) : null }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_enrolment_status(item.status) }}
                  </template>

                  <template v-slot:item.certificate="{ item }">
                    <v-btn
                      text
                      icon
                      v-if="
                        item.tenant_attendee_id &&
                        item.attendee &&
                        item.accomplishment_total == 100 &&
                        item.status == 3 &&
                        predata.date_of_birth
                      "
                      @click="downloadCertificate(item)"
                      class="darken-2"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>

                    <v-btn
                      text
                      icon
                      v-if="item.tenant_attendee_id && item.attendee && item.accomplishment_total == 100 && item.status == 3"
                      @click="downloadCertificate(item, true)"
                      class="darken-2"
                    >
                      <v-icon>fas fa-eye</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <router-link
                      :to="{ path: BACKEND_URL + '/courses/edit/' + item.tenant_course_id, props: { id: item.tenant_course_id } }"
                      v-if="$can('course-edit') && item.tenant_course_id && item.tenant_id == getTenantId"
                    >
                      <action-button type="edit" :icon_only="true" small />
                    </router-link>

                    <action-button
                      type="delete"
                      :icon_only="true"
                      small
                      v-if="$can('course-edit') && !item.tenant_course_id && item.tenant_id == getTenantId"
                      @click="delCertRegCourse(item.id)"
                    />
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsPnlExpExpand" class="cstm-filter mt-4 elevation-0" v-if="participant.id && !modal">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPnlExpIcon }}</v-icon>
                {{ $t("certificates.modulename") }}
              </span>
              <v-spacer></v-spacer>
              <v-flex xs6>
                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2 float-right"
                  color="info"
                  @click.stop="downloadCompiledCertificate(participant.id)"
                  small
                >
                  <v-icon small>fas fa-download</v-icon>
                </v-btn>

                <v-btn
                  class="d-flex-inherit cstm-v-btn darken-2 float-right"
                  color="info"
                  @click.stop="downloadCompiledCertificate(participant.id, true)"
                  small
                >
                  <v-icon small>fas fa-eye</v-icon>
                </v-btn>

                <router-link
                  :to="{ path: BACKEND_URL + '/certificates/create?from_module=participants&from_id=' + this.participant.id }"
                  v-if="$can('certificate-create') && participant.id"
                  @click.prevent="click"
                  class="float-right"
                >
                  <action-button type="new" small :icon_only="true" />
                </router-link>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-flex md12>
                <v-data-table
                  :headers="certificate_headers"
                  :items="certificates"
                  :items-per-page="certificates.length"
                  :options.sync="certificate_pagination"
                  :footer-props="{
                    showFirstLastPage: true,
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="certificate_total"
                  :loading="certificate_show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item="{ item, index }">
                    <tr v-for="(row, idx) in item.row_titles" :key="item.id + '-' + idx" class="grey-tr">
                      <td>
                        <span v-if="item.valid_until_status == 'expired'"> ({{ $t("courses.expired") }}) </span>
                        {{ item.row_titles[idx] }}
                      </td>
                      <td>{{ item.issued_date ? moment.utc(item.issued_date).format(DATE_FORMAT) : null }}</td>
                      <td>
                        <span :class="item.valid_until_status ? 'red--text' : ''">{{
                          item.valid_until ? moment.utc(item.valid_until).format(DATE_FORMAT) : null
                        }}</span>
                      </td>
                      <td>{{ item.issued_by }}</td>
                      <td>{{ item.course_held_by }}</td>
                      <td class="text-end">
                        <router-link
                          :to="{
                            path: BACKEND_URL + '/certificates/edit/' + item.id + '?view=student',
                            params: { id: item.id }
                          }"
                          v-if="$can('certificate-edit')"
                        >
                          <action-button type="edit" :icon_only="true" small />
                        </router-link>

                        <action-button
                          type="delete"
                          :icon_only="true"
                          @click="delCertificate(item.id)"
                          v-if="$can('certificate-delete')"
                          small
                        />
                      </td>
                    </tr>
                    <tr
                      :key="'mt-' + item.id"
                      v-if="item.moduletemplates.filter((i) => i.add_to_expertise == 1).length > 0"
                      class="white-tr"
                    >
                      <td :colspan="6" class="pl-3">
                        <v-simple-table>
                          <tbody>
                            <template v-for="moduletemplate in item.moduletemplates" class="white-tr">
                              <tr :key="'mt-' + moduletemplate.id" class="white-tr">
                                <td :colspan="6" class="pl-0">
                                  <v-btn text small icon @click="clpsExpndModules(moduletemplate.id)">
                                    <v-icon>{{
                                      !mtCollapsed.find((i) => i.id == moduletemplate.id).value ? "expand_less" : "expand_more"
                                    }}</v-icon>
                                  </v-btn>
                                  {{ moduletemplate.name }}
                                </td>
                              </tr>
                              <tr :key="'mo-' + moduletemplate.id" class="white-tr">
                                <td
                                  v-if="
                                    moduletemplate.moduleoptions.length > 0 && !mtCollapsed.find((i) => i.id == moduletemplate.id).value
                                  "
                                  class="pl-5"
                                >
                                  <v-simple-table>
                                    <tbody>
                                      <tr v-for="moduleoption in moduletemplate.moduleoptions" :key="moduleoption.id" class="white-tr">
                                        <td>{{ moduleoption.name }}</td>
                                      </tr>
                                    </tbody>
                                  </v-simple-table>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </v-simple-table>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
          v-model="clpsNotificationLogExpand"
          class="cstm-filter mt-4 elevation-0"
          ref="notificationlog_expansion_panels"
          v-if="participant.id && !modal"
        >
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsNotificationLogIcon }}</v-icon>
                {{ $t("notificationlogs.title") }}
              </span>
              <v-spacer></v-spacer>
              <div class="text-right">
                <v-btn
                  class="cstm-v-btn darken-2"
                  color="success"
                  @click.stop="sendemailtemplatepopup_show()"
                  small
                >
                  <v-icon small>fas fa-paper-plane</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.notify") }}</span>
                </v-btn>
                <v-btn class="d-flex-inherit cstm-v-btn darken-2" color="success" @click.stop="notificationlog_list" small>
                  <v-icon small>fas fa-sync</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.refresh") }}</span>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="nl_headers"
                    :items="notificationlogs"
                    :items-per-page="notificationlogs.length"
                    :options.sync="nl_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="nl_total"
                    :loading="nl_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.type="{ item }">
                      <!--<v-chip color="grey" class="darken-2" dark label small>{{ item.type }}</v-chip>-->
                      {{ item.type }}
                    </template>
                    <template v-slot:item.subject="{ item }">
                      {{ item.type == "email" ? item.subject : item.message }}
                    </template>
                    <template v-slot:item.sender_name="{ item }">
                      {{
                        item.sender_user_id == -1 ? $t("notificationlogs.system_triggered") : item.sender_user_id ? item.sender_name : ""
                      }}
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip :color="item.status_color" class="darken-2" dark label small>{{ item.status }}</v-chip>
                    </template>
                    <template v-slot:item.date_sent="{ item }">
                      {{ item.date_sent ? moment.utc(item.date_sent).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <action-button type="view" :icon_only="true" small @click="showPreviewLogModal(item)" />
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-dialog v-model="showUploadForm" persistent max-width="960px">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                    </v-app-bar>

                    <v-card-text class="pa-4">
                      <ValidationObserver ref="participant_image">
                        <v-flex xs12>
                          <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                            <v-file-input
                              v-model="participant_image"
                              accept=".jpg,.jpeg,.png"
                              color="primary"
                              counter
                              :placeholder="$t('courses.select_image')"
                              prepend-icon="attach_file"
                              outlined
                              :show-size="1000"
                              @change="imageChange"
                              clearable
                              :error="errors.length > 0"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:selection="{ index, text }">
                                <v-chip color="primary" dark label small>
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </ValidationProvider>
                        </v-flex>
                      </ValidationObserver>
                      <v-flex xs12>
                        <v-card
                          @drop.prevent="documentOnDrop($event)"
                          @dragover.prevent="document_dragover = true"
                          @dragenter.prevent="document_dragover = true"
                          @dragleave.prevent="document_dragover = false"
                          :class="{ 'grey lighten-2': document_dragover }"
                        >
                          <v-card-text>
                            <v-row class="d-flex flex-column" dense align="center" justify="center">
                              <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                              <p>{{ $t("global.drop_files_here") }}</p>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUpload" />
                      <action-button type="crop" @click="setupCropImage" :text="$t('global.crop_and_upload')" v-if="participant_image" />
                      <!-- <action-button type="upload" @click="updateImage()" v-if="participant_image" /> -->
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showUploadCamera" persistent :max-width="$vuetify.breakpoint.height">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("courses.upload_image") }}</v-toolbar-title>
                    </v-app-bar>

                    <v-card-text class="pa-2">
                      <v-flex xs12>
                        <vue-web-cam
                          ref="webcam"
                          :device-id="cameraDeviceId"
                          width="100%"
                          height="auto"
                          :resolution="{ width: 1920, height: 1080 }"
                          @cameras="cameraList"
                          @camera-change="cameraChange"
                        />
                      </v-flex>
                    </v-card-text>
                    <v-card-actions class="pt-0">
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUploadCamera" />
                      <action-button type="switchcamera" :icon="'fas fa-sync'" @click="cameraSwitch" />
                      <action-button type="upload" :icon="'camera_alt'" @click="cameraCapture" :text="$t('global.capture')" />

                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showCropDialog" persistent :max-width="computedCropDialogWidth">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-card-text>
                      <VueCropper
                        v-show="selectedCropImage"
                        ref="cropper"
                        :src="selectedCropImage"
                        alt="Source Image"
                        :aspect-ratio="7 / 9"
                        dragMode="move"
                        :toggleDragModeOnDblclick="false"
                      ></VueCropper>
                    </v-card-text>
                    <v-card-actions class="pa-2">
                      <action-button type="default" @click="$refs.cropper.rotate(90)" :icon="'rotate_right'" :icon_only="true" />
                      <action-button type="default" @click="$refs.cropper.rotate(-90)" :icon="'rotate_left'" :icon_only="true" />
                      <action-button type="default" @click="$refs.cropper.relativeZoom(0.1)" :icon="'zoom_in'" :icon_only="true" />
                      <action-button type="default" @click="$refs.cropper.relativeZoom(-0.1)" :icon="'zoom_out'" :icon_only="true" />
                      <v-spacer></v-spacer>
                      <action-button type="upload" @click="cropImage()" :icon_only="$vuetify.breakpoint.xsOnly" />
                      <action-button type="cancel" @click="cancelCropImage" :icon_only="$vuetify.breakpoint.xsOnly" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showUploadDocumentForm" persistent max-width="960px">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("participants.upload_documents") }}</v-toolbar-title>
                    </v-app-bar>

                    <v-card-text class="pa-4">
                      <ValidationObserver ref="upload_document">
                        <v-flex xs12>
                          <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                            <v-file-input
                              name="document"
                              v-model="files"
                              color="primary"
                              counter
                              multiple
                              :placeholder="$t('participants.upload_documents')"
                              prepend-icon="attach_file"
                              outlined
                              :show-size="1000"
                              clearable
                              :error="errors.length > 0"
                              :error-messages="errors[0]"
                            >
                              <template v-slot:selection="{ index, text }">
                                <v-chip color="primary" dark label small>
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </ValidationProvider>
                        </v-flex>
                      </ValidationObserver>
                      <v-flex xs12>
                        <v-card
                          @drop.prevent="documentOnDropFiles($event)"
                          @dragover.prevent="document_dragover_files = true"
                          @dragenter.prevent="document_dragover_files = true"
                          @dragleave.prevent="document_dragover_files = false"
                          :class="{ 'grey lighten-2': document_dragover_files }"
                        >
                          <v-card-text>
                            <v-row class="d-flex flex-column" dense align="center" justify="center">
                              <v-icon :class="[document_dragover_files ? 'mt-2, mb-6' : 'mt-5']" size="60"> mdi-cloud-upload </v-icon>
                              <p>{{ $t("global.drop_files_here") }}</p>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUploadDocument" />
                      <action-button @click="uploadDocument()" type="upload" :disabled="files.length == 0" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showFileUpdate" persistent max-width="480px">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("participants.update_document") }}</v-toolbar-title>
                    </v-app-bar>
                    <v-card-text>
                      <v-text-field
                        v-model="computedFileName"
                        :label="$t('attendees.filename')"
                        :suffix="'.' + computedFileExtension"
                        required
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />

                      <action-button type="cancel" @click="cancelUpdateFile" />
                      <action-button @click="updateFile()" type="save" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>

        <v-dialog v-model="showCourseComment" persistent max-width="480px">
          <div class="form-modal pa-4">
            <v-container class="pa-0">
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-card>
                    <v-app-bar flat dense color="secondary">
                      <v-toolbar-title class="subheading">{{ $t("courses.update_comment") }}</v-toolbar-title>
                    </v-app-bar>
                    <v-card-text class="pa-2">
                      <v-textarea
                        v-model="selectedCourseComment"
                        :label="$t('courses.comment')"
                        required
                        autocomplete="new-password"
                      ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />

                      <action-button type="cancel" @click="cancelCourseComment" />
                      <action-button @click="updateCourseComment" type="save" />
                    </v-card-actions>
                  </v-card>
                </v-container>
              </v-form>
            </v-container>
          </div>
        </v-dialog>
      </v-container>
    </v-form>

    <v-dialog v-model="showDialogForm" persistent max-width="960px">
      <div class="form-modal pa-4">
        <component
          :is="currentLoadedForm.form"
          :id="currentLoadedForm.id"
          :participant="participant"
          :participant_id="currentLoadedForm.participant_id"
          :enrolment_organisation_id="currentLoadedForm.id"
          :modal="true"
          @return_modal_form="return_modal_form"
          @return_modal_cancel_form="return_modal_cancel_form"
        ></component>
      </div>
    </v-dialog>

    <courseListPopup
      :show="showCourseListPopup"
      :except_ids="courseIds"
      :status_ids="[1]"
      :number_of_enrolees="1"
      :show_course_filter="false"
      :show_coursetype_filter="true"
      @callback_courselistpopup_cancel="callback_courselistpopup_cancel"
      @callback_courselistpopup_submit="callback_courselistpopup_submit"
    />

    <enrOrgListPopup
      :show="showEnrOrgListPopup"
      @callback_enrorglistpopup_cancel="callback_enrorglistpopup_cancel"
      @callback_enrorglistpopup_submit="callback_enrorglistpopup_submit"
    />

    <participant-handle-duplicate-popup
      :show="showParHandleDupPopup"
      :id="parHandleDupID"
      :new_participant="parHandleDupNewParticipant"
      @callback_parhandledup_cancel="callback_parhandledup_cancel"
      @callback_parhandledup_merge="callback_parhandledup_merge"
    />

    <sendEmailTemplatePopup
      :show="showSendEmailTemplatePopup"
      :module="'participant'"
      :module_id="participant.id"
      @callback_sendemailtemplatepopup_cancel="callback_sendemailtemplatepopup_cancel"
      @callback_sendemailtemplatepopup_send_success="callback_sendemailtemplatepopup_send_success"
      @callback_sendemailtemplatepopup_send_failed="callback_sendemailtemplatepopup_send_failed"
    />

    <preview-file :show="previewShowModal" :src="previewSrc" :filename="previewFilename" @callback_close_preview="callback_close_preview" />
    <preview-log :show="previewLogShowModal" :log="selectedLog" @callback_close_preview_log="callback_close_preview_log" />
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import courseListPopup from "../../courses/partials/CourseListPopup.vue"
import enrOrgListPopup from "../../enrolments/partials/EnrolmentOrganisationListPopup.vue"
import VueCropper from "vue-cropperjs"
import "cropperjs/dist/cropper.css"
import { WebCam } from "vue-web-cam"
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"
import sendEmailTemplatePopup from "../../notificationtemplates/partials/SendEmailTemplatePopup.vue"

export default {
  name: "ParticipantForm",

  props: ["id", "modal", "from_id_2", "from_module_2"],

  components: {
    ValidationObserver,
    ValidationProvider,
    courseListPopup,
    enrOrgListPopup,
    VueCropper,
    VueTelInputVuetify,
    "vue-web-cam": WebCam,
    "company-form": () => import("../../enrolments/components/ViewOrganisation"),
    "participant-note-form": () => import("@/modules/participants/partials/ParticipantInternalNoteForm"),
    "enrolment-organisation-user-form": () => import("@/modules/enrolments/partials/EnrolmentOrganisationUserForm"),
    "participant-handle-duplicate-popup": () => import("@/modules/participants/partials/ParticipantHandleDuplicatePopup"),
    "preview-file": () => import("@/mixins/components/previewFile"),
    "preview-log": () => import("@/mixins/components/previewLog"),
    sendEmailTemplatePopup,
  },

  data() {
    return {
      page_title: "",
      predata: {},
      participant: {
        id: null,
        image: null,
        image_base64: ""
      },
      dob_date_menu: false,
      dob_employeed_from: false,

      companies: [],
      studentgroups: [],
      departments: [],
      companiesdd: [],

      from_module: "",
      from_id: "",

      hidePID: true,

      showUploadForm: false,
      participant_image: null,

      showCropDialog: false,
      selectedCropImage: null,
      computedCropDialogWidth: 100,

      showEnrOrgListPopup: false,
      showCourseListPopup: false,
      courseIds: [],

      currentFormId: "",
      currentFormParticipantId: "",
      currentForm: "",
      showDialogForm: false,

      courses: [],
      course_total: 0,
      course_show_loading: false,
      course_show_filter: false,
      course_refresh: false,
      course_pagination: {
        page: this.$getLocalStorage("__parCourseListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      mtCollapsed: [],
      certificates: [],
      certificate_total: 0,
      certificate_show_loading: false,
      certificate_show_filter: false,
      certificate_refresh: false,
      certificate_pagination: {
        page: this.$getLocalStorage("__parCertificateListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },

      showFileUpdate: false,
      selectedDocument: {
        id: null,
        original_filename: null
      },
      document_dragover: false,
      document_dragover_files: false,

      showAddCompanyDialog: false,

      showUploadDocumentForm: false,
      showUploadDocumentFormUploadSite: null,
      files: [],
      documents: [],
      dc_mode: null,
      dc_total_deleted: null,
      dc_show_select: true,
      dc_title: this.$t("participants.documents"),
      dc_ids: [],
      dc_total: 0,
      dc_show_loading: false,
      dc_refresh: false,
      dc_pagination: {
        page: this.$getLocalStorage("__parDocumentListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["original_filename"]
      },

      studentdocuments: [],
      sdc_mode: null,
      sdc_total_deleted: null,
      sdc_show_select: true,
      sdc_title: this.$t("participants.students_documents"),
      sdc_ids: [],
      sdc_total: 0,
      sdc_show_loading: false,
      sdc_refresh: false,
      sdc_pagination: {
        page: this.$getLocalStorage("__parStudentDocumentListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["original_filename"]
      },

      showParHandleDupPopup: false,
      parHandleDupID: null,
      parHandleDupNewParticipant: {},

      selectedInternalDocs: [],
      selectedStudentDocs: [],

      previewShowModal: null,
      previewSrc: null,
      previewFilename: null,

      previewLogShowModal: null,
      selectedLog: null,

      showCourseComment: false,
      selectedCourseCommentId: null,
      selectedCourseComment: null,

      sg_studentgroups: [],
      sg_ids: [],
      sg_total: 0,
      sg_show_loading: false,
      sg_refresh: false,
      sg_pagination: {
        page: this.$getLocalStorage("__parStudentGroupListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["original_filename"]
      },

      companies: [],
      cmp_ids: [],
      cmp_total: 0,
      cmp_show_loading: false,
      cmp_refresh: false,
      cmp_pagination: {
        page: this.$getLocalStorage("__parCompaniesListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["name"]
      },
      search_cmp_params: {
        any: ""
      },

      internalnotes: [],
      in_ids: [],
      in_total: 0,
      in_show_loading: false,
      in_refresh: false,
      in_pagination: {
        page: this.$getLocalStorage("__parInternalNotesListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["original_filename"]
      },

      notificationlogs: [],
      nl_ids: [],
      nl_total: 0,
      nl_show_loading: false,
      nl_refresh: false,
      nl_pagination: {
        page: this.$getLocalStorage("__parNotificationLogListPage", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: []
      },

      showSendEmailTemplatePopup: false,
      reRenderSendEmailTemplatePopup: 0,

      clpsPnlAddressIcon: "mdi-collapse-all-outline",
      clpsPnlAddressExpand: 0,

      clpsPnlCompaniesIcon: "mdi-collapse-all-outline",
      clpsPnlCompaniesExpand: 0,

      clpsPnlSGIcon: "mdi-collapse-all-outline",
      clpsPnlSGExpand: 0,

      clpsPnlINIcon: "mdi-collapse-all-outline",
      clpsPnlINExpand: 0,

      clpsPnlIntDocIcon: "mdi-collapse-all-outline",
      clpsPnlIntDocExpand: 0,

      clpsPnlDocIcon: "mdi-collapse-all-outline",
      clpsPnlDocExpand: 0,

      clpsPnlCourseIcon: "mdi-collapse-all-outline",
      clpsPnlCourseExpand: 0,

      clpsPnlExpIcon: "mdi-collapse-all-outline",
      clpsPnlExpExpand: 0,

      clpsNotificationLogIcon: "mdi-expand-all-outline",
      clpsNotificationLogExpand: 0,

      dictionary: {
        attributes: {
          "participant.pid": this.$t("participants.pid"),
          "participant.company_id": this.$t("participants.company_id"),
          "participant.first_name": this.$t("participants.first_name"),
          "participant.last_name": this.$t("participants.last_name"),
          "participant.email": this.$t("participants.email"),
          "participant.mobile": this.$t("participants.mobile"),
          "participant.date_of_birth": this.$t("participants.date_of_birth"),
          "participant.street": this.$t("participants.street"),
          "participant.city": this.$t("participants.city"),
          "participant.state": this.$t("participants.state"),
          "participant.zip": this.$t("participants.zip"),
          "participant.country": this.$t("participants.country"),
          "participant.employee_number": this.$t("participants.employee_number")
        }
      },

      uploadSelections: [
        { key: "file", label: this.$t("global.from_file") },
        { key: "camera", label: this.$t("global.from_camera") }
      ],

      showUploadCamera: false,
      cameraImg: null,
      camera: null,
      cameraDeviceId: null,
      cameraDevices: []
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.participant, this.predata, this.save, this.isFormValid)
    })
  },

  watch: {
    course_refresh: {
      handler() {
        if (this.course_refresh && this.participant.id) {
          this.course_list()
        }
      }
    },
    course_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parCourseListPage", newVal.page)
          }

          this.course_refresh = true
        }
      }
    },
    certificate_refresh: {
      handler() {
        if (this.certificate_refresh && this.participant.id) {
          this.certificate_list()
        }
      }
    },
    certificate_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parCertificateListPage", newVal.page)
          }

          this.certificate_refresh = true
        }
      }
    },
    dc_refresh: {
      handler() {
        if (this.dc_refresh && this.id) {
          this.document_list()
        }
      }
    },
    dc_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parDocumentListPage", newVal.page)
          }

          this.dc_refresh = true
        }
      }
    },
    sdc_refresh: {
      handler() {
        if (this.sdc_refresh && this.id) {
          this.student_document_list()
        }
      }
    },
    sdc_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parStudentDocumentListPage", newVal.page)
          }

          this.sdc_refresh = true
        }
      }
    },
    sg_refresh: {
      handler() {
        if (this.sg_refresh && this.id) {
          this.studentgroup_list()
        }
      }
    },
    sg_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parStudentGroupListPage", newVal.page)
          }

          this.sg_refresh = true
        }
      }
    },
    cmp_refresh: {
      handler() {
        if (this.cmp_refresh && this.id) {
          this.companies_list()
        }
      }
    },
    cmp_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parCompaniesListPage", newVal.page)
          }

          this.cmp_refresh = true
        }
      }
    },
    in_refresh: {
      handler() {
        if (this.in_refresh && this.id) {
          this.internalnote_list()
        }
      }
    },
    in_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parInternalNotesListPage", newVal.page)
          }

          this.in_refresh = true
        }
      }
    },
    nl_refresh: {
      handler() {
        if (this.nl_refresh) {
          this.notificationlog_list()
        }
      }
    },
    nl_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__parNotificationLogListPage", newVal.page)
          }

          this.nl_refresh = true
        }
      }
    },
    clpsPnlAddressExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlAddressIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPnlCompaniesExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlCompaniesIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPnlSGExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlSGIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPnlINExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlINIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPnlIntDocExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlIntDocIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPnlDocExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlDocIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPnlCourseExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlCourseIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPnlExpExpand: {
      handler(newVal, oldVal) {
        this.clpsPnlExpIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsNotificationLogExpand: {
      handler(newVal, oldVal) {
        this.clpsNotificationLogIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    camera: function (id) {
      this.deviceId = id
    }
  },

  computed: {
    getTenantId() {
      return this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`)
    },
    isAdmin() {
      return this.$hasRole("system-developer") || this.$hasRole("organisation-admin")
    },
    isCompany() {
      let user = this.$store.getters["auth/localUser"]
      let bool = false

      if (user) {
        _.forEach(user.roles, function (role) {
          if (role.slug == "company") bool = true
        })
      }

      return bool
    },
    cameraDevice: function () {
      return this.cameraDevices.find((n) => n.deviceId === this.cameraDeviceId)
    },
    course_headers: {
      get() {
        return [
          { text: this.$t("courses.name"), value: "name", width: "30%" },
          { text: this.$t("courses.start_datetime"), value: "start_datetime", width: "10%" },
          { text: this.$t("courses.end_datetime"), value: "end_datetime", width: "10%" },
          { text: this.$t("courses.organisation"), value: "organisation_name", width: "15%" },
          { text: this.$t("participants.type"), value: "status", width: "10%" },
          { text: this.$t("attendees.course_certificate"), value: "certificate", width: "10%", sortable: false },
          { text: this.$t("global.actions"), value: "actions", width: "10%", align: "end" }
        ]
      }
    },
    certificate_headers: {
      get() {
        return [
          { text: this.$t("certificates.title"), value: "title" },
          { text: this.$t("certificates.issued_date"), value: "issued_date" },
          { text: this.$t("courses.valid_until"), value: "valid_until" },
          { text: this.$t("certificates.issued_by"), value: "issued_by" },
          { text: this.$t("certificates.course_held_by"), value: "course_held_by" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]
      }
    },
    dc_headers: {
      get() {
        let headers = [
          { text: this.$t("certificates.filename"), value: "original_filename" },
          { text: this.$t("certificates.size"), value: "size" },
          { text: this.$t("certificates.created_at"), value: "created_at" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]

        if (this.dc_mode == "deleted") {
          headers.splice(3, 0, { text: this.$t("certificates.deleted_on"), value: "deleted_at" })
          headers.splice(4, 0, { text: this.$t("certificates.removed_on"), value: "deleted_on" })
        }

        return headers
      }
    },
    sdc_headers: {
      get() {
        let headers = [
          { text: this.$t("certificates.filename"), value: "original_filename" },
          { text: this.$t("certificates.size"), value: "size" },
          { text: this.$t("certificates.created_at"), value: "created_at" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]

        if (this.sdc_mode == "deleted") {
          headers.splice(3, 0, { text: this.$t("certificates.deleted_on"), value: "deleted_at" })
          headers.splice(4, 0, { text: this.$t("certificates.removed_on"), value: "deleted_on" })
        }

        return headers
      }
    },
    sg_headers: {
      get() {
        return [
          { text: this.$t("studentgroups.groupcode"), value: "name" },
          { text: this.$t("studentgroups.educationprogram_id"), value: "educationprogram_id" },
          { text: this.$t("studentgroups.status"), value: "status" },
          { text: this.$t("global.added_date"), value: "created_at" },
          { text: this.$t("global.updated_date"), value: "updated_at" }
        ]
      }
    },
    cmp_headers: {
      get() {
        return [
          { text: this.$t("participants.company_id"), value: "name" },
          { text: this.$t("participants.employee_number"), value: "employee_number" },
          { text: this.$t("enrolments.department"), value: "department_id" },
          { text: this.$t("enrolments.company_admin"), value: "user_id" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end", sortable: false }
        ]
      }
    },
    in_headers: {
      get() {
        return [
          { text: this.$t("participants.in_note"), value: "note" },
          { text: this.$t("participants.created_by"), value: "created_by_name" },
          { text: this.$t("global.added_date"), value: "created_at" },
          { text: this.$t("global.actions"), value: "actions", width: "20%", align: "end" }
        ]
      }
    },
    nl_headers: {
      get() {
        return [
          { text: this.$t("notificationlogs.type"), value: "type", width: "90px" },
          { text: this.$t("notificationlogs.date_sent"), value: "date_sent" },
          { text: this.$t("notificationlogs.recipient"), value: "recipient" },
          { text: this.$t("notificationlogs.subject"), value: "subject" },
          { text: this.$t("notificationlogs.sender"), value: "sender_name" },
          { text: this.$t("notificationlogs.status"), value: "status" },
          { text: this.$t("global.actions"), value: "actions", width: "10%", align: "end" }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedDateofBirth: {
      get() {
        return this.$dateFormatGetter(this.participant.date_of_birth)
      },
      set(val) {
        this.$set(this.participant, "date_of_birth", this.$dateFormatSetter(val))
      }
    },
    computedEmployeedFrom: {
      get() {
        return this.$dateFormatGetter(this.participant.employeed_from)
      },
      set(val) {
        this.$set(this.participant, "employeed_from", this.$dateFormatSetter(val))
      }
    },
    computedFileName: {
      get() {
        return this.$getFileName(this.selectedDocument.original_filename)
      },
      set(val) {
        this.$set(this.selectedDocument, "new_filename", val + "." + this.$getFileExtension(this.selectedDocument.original_filename))
      }
    },
    computedFileExtension: {
      get() {
        return this.$getFileExtension(this.selectedDocument.original_filename)
      }
    },
    currentLoadedForm: function () {
      let form,
        participant_id,
        id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
        participant_id = this.currentFormParticipantId
      }

      return {
        id: id,
        participant_id: participant_id,
        form: form
      }
    },
    loggedinuser: {
      get() {
        return this.$store.getters["auth/user"]
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
    this.$addLog(null, "participant", this.id, "view", "")
  },

  created() {
    this.from_module = this.$route.query.from_module
    this.from_id = this.$route.query.from_id

    if (!this.from_module && this.from_module_2 == "department") {
      this.from_module = "companies"
      this.from_id = this.from_id_2
    }

    let lists = [
      { key: "addresses", module: "addresses", query: "show_all=true" },
      { key: "studentgroups", module: "studentgroups", query: "show_all=true" },
      { key: "enrolled_organisations", module: "enrolled_organisations", query: "show_all=true" }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.companiesdd = res.data.enrolled_organisations
      this.addresses = res.data.addresses
      this.studentgroups = res.data.studentgroups

      if (!this.id) {
        this.page_title = this.$t("participants.new_participant")
        this.participant = {}

        if (this.companiesdd.length == 1) {
          this.participant.company_id = this.companiesdd[0].id
          this.companiesChange()
        }

        // Set default student if creating of certificate is from Participant module
        if (this.from_module == "companies" && this.from_id) {
          this.participant.company_id = Number(this.from_id)
          this.companiesChange()
        }

        if (this.from_module == "studentgroups" && this.from_id) {
          this.participant.student_group_id = Number(this.from_id)
        }

        // JSON stringify and parse to remove variable reactiveness
        this.loadPredata()
      } else {
        this.title = this.$t("participants.update_title")

        axios
          .get(this.API_URL + "participant/" + this.id)
          .then((res) => {
            this.participant = res.data.data

            this.page_title = this.$t("participants.edit_participant", {
              name: this.participant.first_name + " " + this.participant.last_name
            })

            // JSON stringify and parse to remove variable reactiveness
            this.loadPredata()
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    loadPredata() {
      /*if (this.participant.id && this.participant.companies.length) {
        let company = this.participant.companies[0]
        this.participant.company_id = company.id
        this.participant.employee_number = company.employee_number
      }*/

      this.predata = JSON.parse(JSON.stringify(this.participant))
      this.predata.mobile_code = "47" // Norway country code

      if (this.predata.mobile) {
        let code = PhoneNumber(this.predata.mobile).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.mobile).toJSON()
          this.predata.mobile = mobileJSON.number.significant || this.predata.mobile
          this.predata.mobile_code = code.toString()
        }
      }

      if (!this.participant.id) {
        this.participant.mobile_code = this.predata.mobile_code
      }
    },
    phoneNoSpace() {
      if (this.participant.mobile) {
        this.participant.mobile = this.participant.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "participant.mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    },
    course_list() {
      if (this.participant.id) {
        this.course_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.course_pagination
        let query = this.$queryString(this.course_pagination, { user_id: this.participant_id })

        axios.get(this.API_URL + "participant/allmycourses/" + this.participant.id + "?" + query).then((res) => {
          this.courses = res.data.data
          this.course_total = res.data.meta.total
          this.course_refresh = false
          this.course_show_loading = false

          this.courseIds = this.courses.map((a) => a.id)

          this.course_pagination.page = res.data.meta.current_page
          this.course_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },

    certificate_list() {
      let vm = this
      if (this.participant.id) {
        this.certificate_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.certificate_pagination
        let query = this.$queryString(this.certificate_pagination, { participant_id: this.participant.id, add_to_expertise: 1 })

        this.mtCollapsed = []
        axios.get(this.API_URL + "certificates?" + query).then((res) => {
          this.certificates = res.data.data
          this.certificate_total = res.data.meta.total
          this.certificate_refresh = false
          this.certificate_show_loading = false

          this.certificates.forEach(function (certificate) {
            certificate.moduletemplates = certificate.moduletemplates.filter((mt) => mt.add_to_expertise == 1)
            certificate.moduletemplates.forEach((mt) => {
              mt.moduleoptions = mt.moduleoptions.filter((mo) => mo.add_to_expertise == 1)

              vm.mtCollapsed.push({ id: mt.id, value: true })
            })
          })

          this.certificate_pagination.page = res.data.meta.current_page
          this.certificate_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },

    internalnote_list() {
      let vm = this
      if (this.participant.id) {
        this.in_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.in_pagination
        let query = this.$queryString(this.in_pagination, { participant_id: this.participant.id })

        axios.get(this.API_URL + "participant/notes?" + query).then((res) => {
          this.internalnotes = res.data.data
          this.in_total = res.data.meta.total
          this.in_refresh = false
          this.in_show_loading = false
          this.in_pagination.page = res.data.meta.current_page
          this.in_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
      }
    },

    imageChange(e) {
      if (!e) {
        this.participant.image_url = this.predata.image_url
      }
    },

    openUpload(action) {
      if (action == "camera") this.openUploadCamera()
      if (action == "file") this.openUploadForm()
    },

    openUploadCamera() {
      this.showUploadCamera = true
      this.cameraStart()
    },
    cancelUploadCamera() {
      this.showUploadCamera = false
      this.participant_image = null
      this.cameraStop()
    },

    openUploadForm() {
      this.showUploadForm = true
    },

    cancelUpload() {
      this.showUploadForm = false
      this.participant_image = null
      this.participant.image_url = this.predata.image_url

      this.showCropDialog = false
      this.selectedCropImage = null
    },

    updateImage() {
      let vm = this

      if (this.participant_image) {
        var tmppath = URL.createObjectURL(this.participant_image)

        if (tmppath) {
          vm.$set(vm.participant, "image_url", tmppath)
          vm.showUploadForm = false
          vm.showUploadCamera = false
          vm.cameraStop()
        }
      }
    },

    uploadImage() {
      let vm = this
      let formData = new FormData()

      if (this.participant_image) {
        formData.append("id", this.participant.id)
        formData.append("participant_image", this.participant_image)

        axios
          .post(this.API_URL + "participant/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then((res) => {
            vm.participant = res.data.data
            vm.loadPredata()

            vm.$awn.success(vm.$t("global.update_success"))
            vm.cancelUpload()
            vm.cancelUploadCamera()
          })
          .catch((err) => console.log(err))
      }
    },
    async documentOnDrop(e) {
      this.document_dragover = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.participant_image = file
          }
        }
      }

      if (this.$refs.participant_image) {
        await this.$refs.participant_image.validate()
      }
    },
    async setupCropImage() {
      let vm = this

      if (this.$refs.participant_image) {
        const isValid = await this.$refs.participant_image.validate()
        if (!isValid) {
          return
        }
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader()
        reader.onload = (event) => {
          vm.selectedCropImage = event.target.result

          let img = new Image()
          img.src = vm.selectedCropImage
          img.onload = () => {
            // compute for crop dialog width
            var window_width = vm.$vuetify.breakpoint.width
            var window_height = vm.$vuetify.breakpoint.height

            var img_width = img.naturalWidth
            var img_height = img.naturalHeight

            let obj = vm.$calculateAspectRatioFit(img_width, img_height, window_width, window_height)
            vm.computedCropDialogWidth = obj.width * 0.75 // 0.75 to decrease it by 25%

            vm.showCropDialog = true
            setTimeout(() => {
              vm.$refs.cropper.replace(vm.selectedCropImage)
            }, 200)
          }
        }
        reader.readAsDataURL(this.participant_image)
      } else {
        alert("Sorry, FileReader API not supported")
      }
    },
    cropImage() {
      var base64 = this.$refs.cropper.getCroppedCanvas().toDataURL()

      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        var file = new File([blob], this.participant_image.name, { type: this.participant_image.type })

        this.participant_image = file
        this.updateImage()

        this.showCropDialog = false
        this.selectedCropImage = null
      }, this.participant_image.type)
    },
    cancelCropImage() {
      this.showCropDialog = false
    },
    verifyImage() {
      let vm = this

      axios
        .post(this.API_URL + "participant/verifyImage", {
          id: this.participant.id
        })
        .then((res) => {
          vm.participant = res.data.data
          vm.loadPredata()
          vm.$awn.success(vm.$t("global.update_success"))
        })
        .catch((err) => console.log(err))
    },

    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            axios
              .post(this.API_URL + "participant/checkExist", {
                id: this.participant.id ? this.participant.id : null,
                email: this.participant.email,
                mobile: this.$formatPhoneNumber(this.participant.mobile, this.participant.mobile_code)
              })
              .then((res) => {
                let status = res.data.status
                let record = res.data.record

                if (status == "ok") {
                  if (!this.participant.id) {
                    // Create
                    this.createRecord()
                  } else {
                    // Update
                    this.updateRecord()
                  }
                } else if (status == "exist-in-tenant") {
                  this.showParHandleDupPopupModal(record)
                } else if (status == "exist") {
                  this.showParHandleDupPopupModal(record)
                }
              })
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    createRecord() {
      let vm = this
      let user = this.$store.getters["auth/user"]

      axios
        .post(this.API_URL + "participant", {
          company_id: this.participant.company_id || null,
          company_department_id: this.participant.company_department_id || null,
          employee_number: this.participant.employee_number || null,
          first_name: this.participant.first_name,
          middle_name: this.participant.middle_name,
          last_name: this.participant.last_name,
          email: this.participant.email,
          pid: this.participant.pid,
          mobile: this.$formatPhoneNumber(this.participant.mobile, this.participant.mobile_code),
          date_of_birth: this.participant.date_of_birth,
          student_group_id: this.participant.student_group_id,
          street: this.participant.street,
          city: this.participant.city,
          state: this.participant.state,
          zip: this.participant.zip,
          country: this.participant.country,
          employeed_from: this.participant.employeed_from,
          comments: this.participant.comments,
          status: this.participant.status,
          created_by: user.id,
          tenant_user_status: this.participant.tenant_user_status,
          from_module: this.from_module_2 // ParticipantListPopup
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            if (res.data.data.id) {
              vm.participant = res.data.data
              vm.loadPredata()

              vm.uploadImage()
              vm.$awn.success(vm.$t("global.create_success"))

              this.companies_list()

              if (vm.modal) {
                vm.$emit("return_modal_form", {
                  module: "participants",
                  mode: "add",
                  data: vm.participant
                })
              } else {
                if (vm.from_id) {
                  if (vm.from_module == "companies") {
                    vm.$router.push(this.BACKEND_URL + "/enrolments/organisations/view/" + vm.from_id)
                  } else if (vm.from_module == "studentgroups") {
                    vm.$router.push(this.BACKEND_URL + "/studentgroups/edit/" + vm.from_id)
                  } else {
                    vm.$router.push(this.BACKEND_URL + "/" + vm.from_module + "/edit/" + vm.from_id)
                  }
                } else {
                  vm.page_title = vm.$t("participants.edit_participant", {
                    name: vm.participant.first_name + " " + vm.participant.last_name
                  })
                  vm.$router.replace(this.BACKEND_URL + `/participants/edit/${vm.participant.id}`).catch(() => {})
                }
              }
            }
          }
        })
        .catch((err) => console.log(err))
    },
    updateRecord() {
      let vm = this

      axios
        .put(this.API_URL + "participant", {
          id: this.participant.id,
          company_id: this.participant.company_id || null,
          company_department_id: this.participant.company_department_id || null,
          employee_number: this.participant.employee_number || null,
          first_name: this.participant.first_name,
          middle_name: this.participant.middle_name,
          last_name: this.participant.last_name,
          email: this.participant.email,
          pid: this.participant.pid,
          mobile: this.$formatPhoneNumber(this.participant.mobile, this.participant.mobile_code),
          date_of_birth: this.participant.date_of_birth,
          student_group_id: this.participant.student_group_id,
          street: this.participant.street,
          city: this.participant.city,
          state: this.participant.state,
          zip: this.participant.zip,
          country: this.participant.country,
          employeed_from: this.participant.employeed_from,
          comments: this.participant.comments,
          status: this.participant.status,
          tenant_user_status: this.participant.tenant_user_status,
          from_module: this.from_module_2 // ParticipantListPopup
        })
        .then((res) => {
          vm.participant = res.data.data
          vm.loadPredata()

          vm.page_title = vm.$t("participants.edit_participant", {
            name: vm.participant.first_name + " " + vm.participant.last_name
          })

          vm.uploadImage()
          vm.callback_parhandledup_cancel()
          vm.$awn.success(vm.$t("global.update_success"))

          this.companies_list()

          if (vm.modal) {
            vm.$emit("return_modal_form", {
              module: "participants",
              mode: "edit",
              data: vm.participant
            })
          } else {
            if (vm.from_module == "companies") {
              vm.$router.push(this.BACKEND_URL + "/enrolments/organisations/view/" + vm.from_id)
            } else {
              vm.$router.replace(this.BACKEND_URL + `/participants/edit/${vm.participant.id}`).catch(() => {})
            }
          }
        })
        .catch((err) => console.log(err))
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "participant/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/participants")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    addParticipantToTenant(id) {
      return axios.post(this.API_URL + "participant/addStudentToTenant", {
        id: id
      })
    },
    delCertificate(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "certificate/" + id)
            .then((res) => {
              vm.certificate_list()
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    studentgroup_list() {
      if (this.participant.id) {
        this.sg_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.sg_pagination
        let query = this.$queryString(this.sg_pagination, { participant_id: this.participant.id })

        axios
          .get(this.API_URL + "studentgroups/participants" + "?" + query)
          .then((res) => {
            this.sg_studentgroups = res.data.data
            this.sg_total = res.data.meta.total
            this.sg_refresh = false
            this.sg_show_loading = false

            this.sg_pagination.page = res.data.meta.current_page
            this.sg_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    companies_list() {
      let id = this.id || this.participant.id

      if (id) {
        this.cmp_show_loading = true

        let { sortBy, descending, page, itemsPerPage } = this.cmp_pagination
        let query = this.$queryString(this.cmp_pagination, {
          ...this.search_cmp_params,
          participant_id: id
        })

        axios
          .get(this.API_URL + "enrolments/organisations" + "?" + query)
          .then((res) => {
            this.companies = res.data.data
            this.cmp_total = res.data.meta.total
            this.cmp_refresh = false
            this.cmp_show_loading = false

            this.cmp_pagination.page = res.data.meta.current_page
            this.cmp_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    filterCompanies(target) {
      this.cmp_refresh = true
    },
    checkKeyPressFilterCompany(e) {
      if (e.key == "Enter") {
        this.filterCompanies()
      }
    },
    document_list() {
      let tenant_id = this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`)
      if (this.participant.id) {
        this.dc_show_loading = true

        let ids = this.dc_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.dc_pagination
        let query = this.$queryString(this.dc_pagination, { participant_id: this.participant.id, tenant_id: tenant_id })

        axios
          .get(this.API_URL + "participant/documents" + "?mode=" + this.dc_mode + "&" + query)
          .then((res) => {
            this.documents = res.data.data
            this.dc_total = res.data.meta.total
            this.dc_total_deleted = res.data.total_deleted
            this.dc_refresh = false
            this.dc_show_loading = false

            this.dc_pagination.page = res.data.meta.current_page
            this.dc_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    student_document_list() {
      if (this.participant.id) {
        this.sdc_show_loading = true

        let ids = this.sdc_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.sdc_pagination
        let query = this.$queryString(this.sdc_pagination, { participant_id: this.participant.id })

        axios
          .get(this.API_URL + "participant/documents" + "?mode=" + this.sdc_mode + "&" + query)
          .then((res) => {
            this.studentdocuments = res.data.data
            this.sdc_total = res.data.meta.total
            this.sdc_total_deleted = res.data.total_deleted
            this.sdc_refresh = false
            this.sdc_show_loading = false

            this.sdc_pagination.page = res.data.meta.current_page
            this.sdc_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },
    toggleDocumentList() {
      if (this.dc_mode == null) {
        this.dc_mode = "deleted"
        this.dc_show_select = false
        this.dc_title = this.$t("participants.documents") + " " + this.$t("participants.deleted_documents")
      } else {
        this.dc_mode = null
        this.dc_show_select = true
        this.dc_title = this.$t("participants.documents")
      }
      this.document_list()
    },
    restoreDocument(file) {
      let vm = this

      axios
        .post(this.API_URL + "participant/documents/restore/" + file.id)
        .then((res) => {
          vm.document_list()
          vm.$awn.success(vm.$t("global.restore_success"))
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    toggleStudentDocumentList() {
      if (this.sdc_mode == null) {
        this.sdc_mode = "deleted"
        this.sdc_show_select = false
        this.sdc_title = this.$t("participants.students_documents") + " " + this.$t("participants.deleted_documents")
      } else {
        this.sdc_mode = null
        this.sdc_show_select = true
        this.sdc_title = this.$t("participants.students_documents")
      }
      this.student_document_list()
    },
    restoreStudentDocument(file) {
      let vm = this

      axios
        .post(this.API_URL + "participant/documents/restore/" + file.id)
        .then((res) => {
          vm.student_document_list()
          vm.$awn.success(vm.$t("global.restore_success"))
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    downloadDocument(id, module, filename, preview = false) {
      axios({
        url: this.API_URL + "participant/documents/download",
        method: "POST",
        responseType: "arraybuffer",
        data: {
          id: id,
          module: module
        }
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))

            if (!preview) {
              const link = document.createElement("a")
              link.href = url
              link.setAttribute("download", filename)
              link.click()
            } else {
              this.showPreviewModal(url, filename)
            }
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },
    async uploadDocument() {
      let vm = this
      let formData = new FormData()

      if (this.$refs.upload_document) {
        const isValid = await this.$refs.upload_document.validate()
        if (!isValid) {
          return
        }
      }

      formData.append("id", this.participant.id)

      if (this.showUploadDocumentFormUploadSite) {
        formData.append("upload_site", this.showUploadDocumentFormUploadSite)
      }

      this.files.forEach((file, index) => {
        formData.append("files[" + index + "]", file)
      })

      axios
        .post(this.API_URL + "participant/documents/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          vm.files = []

          if (this.showUploadDocumentFormUploadSite == "kursweb") {
            vm.document_list()
          }

          if (this.showUploadDocumentFormUploadSite == "kompetanse") {
            vm.student_document_list()
          }

          vm.cancelUploadDocument()
        })
        .catch((err) => console.log(err))
    },
    async documentOnDropFiles(e) {
      this.document_dragover_files = false
      if (e.dataTransfer.files.length) {
        Array.from(e.dataTransfer.files).forEach((file) => {
          this.files.push(file)
        })
      }

      if (this.$refs.upload_document) {
        await this.$refs.upload_document.validate()
      }
    },
    deleteDocument(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "participant/documents/delete/" + id)
            .then((res) => {
              vm.document_list()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    openUploadDocumentForm(site = null) {
      this.showUploadDocumentFormUploadSite = site
      this.showUploadDocumentForm = true
      this.files = []
    },
    cancelUploadDocument() {
      this.showUploadDocumentForm = false
      this.files = []
    },
    openUpdateFile(id) {
      axios
        .get(this.API_URL + "participant/documents/get/" + id)
        .then((res) => {
          this.selectedDocument = res.data.data
          this.selectedDocument["new_filename"] = this.selectedDocument.original_filename
        })
        .catch((err) => console.log(err))

      this.showFileUpdate = true
    },
    updateFile() {
      if (this.selectedDocument) {
        axios
          .put(this.API_URL + "participant/documents/update", {
            id: this.selectedDocument.id,
            filename: this.selectedDocument.new_filename
          })
          .then((res) => {
            this.$awn.success(this.$t("global.update_success"))

            let inDoc = this.documents.find((i) => i.id == this.selectedDocument.id)
            if (inDoc) {
              this.document_list()
            }

            let inStuDoc = this.studentdocuments.find((i) => i.id == this.selectedDocument.id)
            if (inStuDoc) {
              this.student_document_list()
            }

            this.cancelUpdateFile()
          })
          .catch((err) => console.log(err))
      }
    },
    moveCopyFileTo(action, type) {
      let ids = []
      let tenant_id = null

      if (type == "kursweb") {
        ids = this.selectedStudentDocs.map((i) => i.id)
        tenant_id = this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`)
      }

      if (type == "kompetanse") {
        ids = this.selectedInternalDocs.map((i) => i.id)
      }

      if (ids) {
        axios
          .put(this.API_URL + "participant/documents/update", {
            __action__: action,
            __type__: type,
            ids: ids,
            tenant_id: tenant_id
          })
          .then((res) => {
            if (type == "copy") {
              this.$awn.success(this.$t("global.copy_file_success"))
            }

            if (type == "move") {
              this.$awn.success(this.$t("global.move_file_success"))
            }

            this.document_list()
            this.student_document_list()
          })
          .catch((err) => console.log(err))
      }

      this.selectedStudentDocs = []
      this.selectedInternalDocs = []
    },
    cancelUpdateFile() {
      this.showFileUpdate = false
      this.selectedDocument = {
        id: null,
        original_filename: null
      }
    },

    courselistpopup_show() {
      this.showCourseListPopup = true
    },
    callback_courselistpopup_submit(data) {
      this.callback_courselistpopup_cancel()

      let ids = data.map((i) => i.id)
      let vm = this

      axios
        .post(this.API_URL + "participant/createAttendee", {
          participant_ids: this.participant.id,
          course_ids: ids.join(","),
          site: process.env.VUE_APP_DOMAIN,
          subdomain: vm.SUBDOMAIN
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            let json = res.data

            if (json.status) {
              vm.$awn.success(
                json.hasOwnProperty("hasSkipUser") && json.hasSkipUser
                  ? vm.$t("enrolments.multi_enrolment_successful_with_skip")
                  : vm.$t("global.create_success")
              )
            } else {
              vm.$awn.alert(vm.$t("enrolments.multi_enrolment_failed"))
            }

            vm.course_refresh = true
          }
        })
        .catch((err) => console.log(err))
    },
    callback_courselistpopup_cancel() {
      this.showCourseListPopup = false
    },

    zipCodeChange() {
      this.$getCity(this.participant.zip, this.participant.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.participant, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.participant, "city", null)
        })
    },

    downloadCertificate(item, preview = false) {
      let vm = this

      if (item.attendee.certificate_filename && item.attendee.p360_archived_date && item.attendee.p360_pdf_filename) {
        axios({
          url: this.API_URL + "s3/download?file=" + item.attendee.certificate_filename,
          method: "GET",
          responseType: "arraybuffer"
        })
          .then((response) => {
            if (this.$arrayBufferValidation(response.data)) {
              const url = window.URL.createObjectURL(new Blob([response.data]))

              if (!preview) {
                const link = document.createElement("a")
                link.href = url
                link.setAttribute("download", "certificate.pdf")
                link.click()
              } else {
                this.showPreviewModal(url, "preview-certificate.pdf")
              }
            }
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      } else {
        axios({
          url: this.API_URL + "attendee/downloadCertificate",
          method: "POST",
          data: {
            id: item.tenant_attendee_id,
            tenant_id: item.tenant_id
          },
          responseType: "arraybuffer"
        })
          .then((response) => {
            if (this.$arrayBufferValidation(response.data)) {
              const url = window.URL.createObjectURL(new Blob([response.data]))

              if (!preview) {
                const link = document.createElement("a")
                link.href = url
                link.setAttribute("download", "certificate.pdf")
                link.click()
              } else {
                this.showPreviewModal(url, "preview-certificate.pdf")
              }
            }
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      }
    },

    showForm(id, participant_id, type) {
      this.currentFormId = id
      this.currentFormParticipantId = participant_id
      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      if (data && data.module == "companies") {
        let record = data.data
        if (record && record.id) {
          this.companies.push(record)
          this.participant.company_id = record.id
        }
      }

      if (data && data.module == "participant-note") {
        this.in_refresh = true
      }

      if (data && data.module == "enrolment-organisation-user") {
        this.cmp_refresh = true
      }

      this.return_modal_cancel_form()
    },
    return_modal_cancel_form(data) {
      this.currentFormId = ""
      this.currentFormParticipantId = ""
      this.currentForm = ""
      this.showDialogForm = false

      if (data && data.module == "enrolment-organisation-user") {
        this.cmp_refresh = true
      }
    },

    cameraCapture() {
      let capture = this.$refs.webcam.capture()
      if (capture) {
        var file = this.$dataURLtoFile(capture, "capture.jpg")
        this.participant_image = file
        this.setupCropImage()
      }
    },
    cameraStop() {
      if (this.$refs.webcam) {
        this.$refs.webcam.stop()
      }
    },
    cameraStart() {
      if (this.$refs.webcam) {
        this.$refs.webcam.start()
      }
    },
    cameraList(cameras) {
      this.cameraDevices = cameras

      const [first] = this.cameraDevices
      if (first) {
        this.camera = first.deviceId
        this.cameraDeviceId = first.deviceId
      }
    },
    cameraChange(deviceId) {
      this.cameraDeviceId = deviceId
      this.camera = deviceId
    },
    cameraSwitch() {
      let idx = this.cameraDevices.findIndex((x) => x.deviceId === this.cameraDeviceId)
      let devicesCount = this.cameraDevices.length

      if (devicesCount > 1) {
        idx = (idx + 1) % devicesCount
        let newCamera = this.cameraDevices[idx]
        if (newCamera) {
          this.cameraChange(newCamera.deviceId)
        }
      }
    },
    clpsExpndModules(id) {
      let idx = this.mtCollapsed.findIndex((i) => i.id == id)
      this.$set(this.mtCollapsed[idx], "value", !this.mtCollapsed[idx].value)
    },

    downloadCompiledCertificate(id, preview = false) {
      let vm = this

      axios({
        url: this.API_URL + "participant/compile-expertise",
        method: "POST",
        responseType: "arraybuffer",
        data: {
          id: id,
          tenant_id: Number(this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`))
        }
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))

            if (!preview) {
              const link = document.createElement("a")
              link.href = url
              link.setAttribute("download", "certificate.pdf")
              link.click()
            } else {
              this.showPreviewModal(url, "preview-certificate.pdf")
            }
          }
        })
        .catch((error) => {})
    },
    showParHandleDupPopupModal(data) {
      this.parHandleDupID = data.id
      this.parHandleDupNewParticipant = this.participant
      this.showParHandleDupPopup = true
    },
    callback_parhandledup_merge(data) {
      let vm = this
      let promise = this.addParticipantToTenant(data.id)

      promise.then((res) => {
        axios.get(this.API_URL + "participant/" + data.id).then((res) => {
          let participant = res.data.data

          Object.keys(data.output).forEach((key) => {
            if (data.output[key]) {
              participant[key] = data.output[key]
            }
          })

          let code = PhoneNumber(participant.mobile).getCountryCode()
          if (code) {
            let mobileJSON = PhoneNumber(participant.mobile).toJSON()
            participant.mobile = mobileJSON.number.significant || participant.mobile
            participant.mobile_code = code.toString()
          }

          // Set default student if creating of certificate is from Participant module
          if (this.from_module == "companies" && this.from_id) {
            participant.company_id = Number(this.from_id)
          }

          if (this.from_module == "studentgroups" && this.from_id) {
            participant.student_group_id = Number(this.from_id)
          }

          this.participant = participant
          this.updateRecord()
        })
      })
    },
    callback_parhandledup_cancel() {
      this.parHandleDupID = null
      this.parHandleDupNewParticipant = {}
      this.showParHandleDupPopup = false
    },
    showPreviewModal(src, filename) {
      this.previewSrc = src
      this.previewFilename = filename
      this.previewShowModal = true
    },
    callback_close_preview() {
      this.previewSrc = null
      this.previewFilename = null
      this.previewShowModal = false
    },
    showPreviewLogModal(log) {
      this.selectedLog = log
      this.previewLogShowModal = true
    },
    callback_close_preview_log() {
      this.previewLogShowModal = false
      this.selectedLog = null
    },
    PIDChange() {
      if (!this.id && this.participant.pid) {
        axios
          .post(this.API_URL + "participant/user-exist", {
            pid: this.participant.pid
          })
          .then((res) => {
            let status = res.data.status
            let record = res.data.data
            let exist_in = res.data.exist_in

            if (status == "exist" && exist_in == "pid") {
              this.$awn.confirm(
                this.$t("participants.pid_exists_confirm"),
                () => {
                  this.$set(this.participant, "first_name", record.first_name)
                  this.$set(this.participant, "last_name", record.last_name)
                  this.$set(this.participant, "email", record.email)
                  this.$set(this.participant, "mobile", record.mobile)

                  if (record.date_of_birth) {
                    this.$set(this.participant, "date_of_birth", this.$dateFormatSetter(record.date_of_birth))
                  }

                  this.$set(this.participant, "street", record.street)
                  this.$set(this.participant, "city", record.city)
                  this.$set(this.participant, "zip", record.zip)
                  this.$set(this.participant, "country", record.country)
                },
                () => {
                  return
                },
                {
                  labels: {
                    confirm: ""
                  }
                }
              )
            }
          })
      }
    },
    deleteNote(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "participant/note/delete/" + id)
            .then((res) => {
              vm.in_refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    delCertRegCourse(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "course/certreg/" + id)
            .then((res) => {
              vm.course_refresh = true
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    showCourseCommentModal(id, comment) {
      this.showCourseComment = true
      this.selectedCourseCommentId = id
      this.selectedCourseComment = comment
    },
    cancelCourseComment() {
      this.showCourseComment = false
      this.selectedCourseCommentId = null
      this.selectedCourseComment = null
    },
    updateCourseComment() {
      let vm = this
      axios
        .put(this.API_URL + "course/certreg/updatefield", {
          id: this.selectedCourseCommentId,
          field: "comment",
          value: this.selectedCourseComment
        })
        .then((res) => {
          vm.course_refresh = true
          vm.cancelCourseComment()
          vm.$awn.success(vm.$t("global.update_success"))
        })
        .catch((err) => console.log(err))
    },
    getCompanyUserId(participant) {
      let company = participant.companies.find((i) => i.id == this.organisation.id)
      if (company && company.user_id) {
        return company.user_id
      }
      return null
    },
    companyUserChange(company, mode, value) {
      let vm = this
      let url = this.API_URL + (value ? "participant/add-company-access" : "participant/remove-company-access")
      let obj = {
        first_name: this.participant.first_name,
        last_name: this.participant.last_name,
        company_name: company.name
      }

      this.$awn.confirm(
        mode == "create" ? this.$t("enrolments.employee_user_access", obj) : this.$t("enrolments.employee_user_remove", obj),
        () => {
          axios
            .post(url, {
              participant_id: this.participant.id,
              company_id: company.id
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                if (mode == "create") {
                  vm.$awn.success(vm.$t("global.create_success"))
                }

                if (mode == "delete") {
                  vm.$awn.success(vm.$t("global.delete_success"))
                }

                vm.cmp_refresh = true
              }
            })
            .catch((err) => console.log(err))
        },
        () => {},
        {
          labels: {
            confirm: ""
          }
        }
      )
    },
    enrorglistpopup_show() {
      this.showEnrOrgListPopup = true
    },
    callback_enrorglistpopup_submit(data) {
      let vm = this
      axios
        .post(this.API_URL + "participant/add-company", {
          participant_id: this.participant.id,
          company_id: data.map((i) => i.id).join(",")
        })
        .then((res) => {
          if (typeof res.data.errors !== "undefined") {
          } else {
            vm.$awn.success(vm.$t("global.create_success"))
            vm.cmp_refresh = true
            vm.callback_enrorglistpopup_cancel()
          }
        })
        .catch((err) => console.log(err))
    },
    callback_enrorglistpopup_cancel() {
      this.showEnrOrgListPopup = false
    },
    companiesChange() {
      if (this.participant.company_id) {
        axios
          .get(
            this.API_URL +
              "enrolmentorganisationdepartments" +
              "?show_all=true&query_enrolment_organisation_id=" +
              this.participant.company_id
          )
          .then((res) => {
            this.departments = res.data.data
          })
          .catch((err) => console.log(err))
      } else {
        this.departments = []
      }
    },
    removeEmployee(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .post(this.API_URL + "participant/remove-company", {
              company_id: id,
              participant_id: this.participant.id
            })
            .then((res) => {
              if (typeof res.data.errors !== "undefined") {
              } else {
                vm.$awn.success(vm.$t("global.delete_success"))
                vm.cmp_refresh = true
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    notificationlog_list() {
      if (this.participant.id) {
        this.nl_show_loading = true

        let ids = this.nl_ids.join(",")
        let { sortBy, descending, page, itemsPerPage } = this.nl_pagination
        let query = this.$queryString(this.nl_pagination, { parent_module: "participant", parent_id: this.participant.id })

        axios
          .get(this.API_URL + "notificationlogs" + "?" + query)
          .then((res) => {
            this.notificationlogs = res.data.data
            this.nl_total = res.data.meta.total
            this.nl_refresh = false
            this.nl_show_loading = false

            this.nl_pagination.page = res.data.meta.current_page
            this.nl_pagination.itemsPerPage = Number(res.data.meta.per_page)
          })
          .catch((err) => console.log(err))
      }
    },

    sendemailtemplatepopup_show() {
      this.showSendEmailTemplatePopup = true
    },
    callback_sendemailtemplatepopup_send_success(data) {
      this.$awn.success(this.$t("notificationtemplates.notification_sent_successfully"))
      this.callback_sendemailtemplatepopup_cancel()
    },
    callback_sendemailtemplatepopup_send_failed(data) {
      this.$awn.alert(this.$t("notificationtemplates.notification_sent_failed"))
      this.callback_sendemailtemplatepopup_cancel()
    },
    callback_sendemailtemplatepopup_cancel() {
      this.showSendEmailTemplatePopup = false
      this.reRenderSendEmailTemplatePopup++
      this.nl_refresh = true
    },
  }
}
</script>

<style>
.white-tr {
  background: #fff !important;
}
.white-tr td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}
.grey-tr {
  background: #f2f2f2 !important;
}
.red-error-text {
  color: var(--v-error-base) !important;
}
.course-comment-icon {
  border: 1px solid #000 !important;
}
</style>
